module.exports = __webpack_public_path__ + "static/sale-798790bfd4640c63d1677ec1dd5869d7.png";